var loaded = false;
export default (function (_ref) {
  var clientId = _ref.clientId,
      nonce = _ref.nonce,
      _ref$redirectURI = _ref.redirectURI,
      redirectURI = _ref$redirectURI === void 0 ? 'https://myprofile.s7.ru' : _ref$redirectURI,
      _ref$scope = _ref.scope,
      scope = _ref$scope === void 0 ? 'name email' : _ref$scope,
      state = _ref.state,
      _ref$usePopup = _ref.usePopup,
      usePopup = _ref$usePopup === void 0 ? true : _ref$usePopup;

  if (loaded) {
    return;
  }

  loaded = true;
  var initInterval = setInterval(function () {
    if (window.AppleID && window.AppleID.auth) {
      clearInterval(initInterval);
      window.AppleID.auth.init({
        clientId: clientId,
        nonce: nonce,
        redirectURI: redirectURI,
        scope: scope,
        state: state,
        usePopup: usePopup
      });
    }
  }, 100);
});